import { buildTranslate } from 'locales'
import './PreferenceBanner.scss'

const t = buildTranslate('components.ai.segment_name_modal')

export interface PreferenceBannerProps {
  preference: { autoApprove: boolean }
  onChangeClicked: () => void
}

const PreferenceBanner = ({
  preference,
  onChangeClicked,
}: PreferenceBannerProps) => (
  <div className="preference-banner" role="status">
    <span className="preference-banner__icon" aria-hidden="true">
      &#9432;
    </span>
    <span className="preference-banner__text">
      {preference.autoApprove
        ? t('preference_banner_auto_approve')
        : t('preference_banner_review')}
    </span>
    <button
      type="button"
      className="preference-banner__change"
      onClick={onChangeClicked}
    >
      {t('preference_banner_change')}
    </button>
  </div>
)

export default PreferenceBanner
